<div class="p-5">
  <fgb-loading></fgb-loading>
</div>
